import React, { useContext, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Config, I18n } from "@deporvillage/utils-library-component";
import Picture from "@deporvillage/picture-component";
import Stars from "@deporvillage/stars-component";

import styles from './FooterReviews.module.scss';

// istanbul ignore next
const isElementInViewport = (elem) => {
    const { top } = elem.getBoundingClientRect();
    /* eslint-disable-next-line no-undef */
    return top && top < window.innerHeight + 100;
};

const formatNumber = (n, t = '.') => n?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, t);

const FooterReviews = ({ rating }) => {

    const elem = useRef(null);
    const { trustpilot } = useContext(Config);
    const ratingScore = rating ? (rating.score / 10).toFixed(1) : null;

    const handleLoadWidget = () => {
        // istanbul ignore next
        if (elem && elem.current && isElementInViewport(elem.current)) {
            /* eslint-disable no-undef */
            let script = document.createElement("script");
            script.src = trustpilot.scriptSrc;
            script.async = true;
            script.setAttribute('fetchpriority', 'low');
            elem.current.appendChild(script);
            window.removeEventListener('scroll', handleLoadWidget);
            /* eslint-enable no-undef */
        }
    };

    useEffect(() => {
        handleLoadWidget();
        /* eslint-disable no-undef */
        window.addEventListener('scroll', handleLoadWidget);
        return () => { window.removeEventListener('scroll', handleLoadWidget); };
        /* eslint-enable no-undef */
    }, []);

    return (
        <div className={styles['footer-reviews-component']}>
            {
                !trustpilot || !trustpilot.enabled.widget ? (
                    <div className={styles['footer-reviews']}>
                        <Picture lazy src={`/static/default/deporvillage_logo_gray.png`}
                            width={116} height={40} name={'Deporvillage'}
                            className={'footer-reviews-logo'}
                        />
                        {rating ? (
                            <div className={styles['footer-reviews-wrapper']}>
                                <div><I18n>footer.rating.score</I18n> <strong>{ratingScore}/10</strong></div>
                                <Stars rate={rating.score} size={'small'} />
                                <div>
                                    <strong>{formatNumber(rating.count)}</strong>
                                    &nbsp;
                                    <span className={styles['footer-reviews-rating']}><I18n>footer.rating.reviews</I18n></span>
                                </div>
                            </div>
                        ) : null}
                    </div>
                ) : (
                    <div
                        className={`trustpilot-widget ${styles['footer-trustpilot-widget']}`}
                        data-locale={trustpilot.local}
                        data-template-id='53aa8807dec7e10d38f59f32'
                        data-businessunit-id={trustpilot.id}
                        data-style-height='90px'
                        data-style-width='130px'
                        data-theme='light'
                        ref={elem}
                    >
                        <a href={trustpilot.url} rel='noopener noreferrer' target='_blank'>
                            Trustpilot
                        </a>
                    </div>
                )

            }
        </div>
    );
};

FooterReviews.propTypes = {
    rating: PropTypes.shape({
        score: PropTypes.number,
        count: PropTypes.number,
    }),
};

export default FooterReviews;
